<template>
  <section
    class="testimonialsSection"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="testimonialsSection__bg">
      
      <div class="testimonialsSection__images">
        <library-image
          
           :src="vars.photoImage"
          
        />
      </div>
    </div>

    <div class="container">
      <div class="row justify-end">
        <div class="col-xl-5 col-lg-6 col-md-7">
          <div class="testimonialsSection__content layout-pt-lg layout-pb-lg">
            <h2 v-html="vars.titleHtml"></h2>
            
       
            <div class="relative overflow-hidden js-section-slider-testimonials">
  <div class="swiper-wrapper">
    <div
      class="swiper-slide"
      v-for="(story, index) in stories"
      :key="index"
    >
      <h5>{{ story.title }}</h5>
      <p class="mt-4">{{ story.description }}</p>
      <button :class="`n-${story.button_type}`" class="tw-mt-auto mt-4">
                  {{ story.button_label }}
                </button>
    </div>
  </div>
</div>

           
<div class="d-flex mt-60 md:mt-30 max-lg:tw-items-center max-lg:tw-justify-center">
          <button class="sliderNav -prev js-prev n-link">
            <i class="icon-left-arrow"></i>
          </button>
          <button class="sliderNav -next ml-20 js-next n-link">
            <i class="icon-right-arrow"></i>
          </button>
        </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'Theme7StoryBox',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
      },
    };
  },

  computed: {
    
    stories() {
      return this.groupedVariables?.stories || [];
    },
  },
});
</script>
